import { render, staticRenderFns } from "./SortBooks.vue?vue&type=template&id=56075151&"
import script from "./SortBooks.vue?vue&type=script&lang=js&"
export * from "./SortBooks.vue?vue&type=script&lang=js&"
import style0 from "./SortBooks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports